<script>
export default {
    name: 'StaleChecker',

    watch: {
        async $route() {
            const appIsStale = await this.$store.dispatch('AppRuntime/isStale');

            if (appIsStale) {
                this.$loading.open({});

                // Add timeout to make transition smooth

                setTimeout(() => {
                    window.location.reload(true);
                }, 3000);
            }
        },
    },

    render: () => null,
};
</script>
